import { SBaseDisplay } from '@summit/core';
import { SummitFormattedText } from '@summit/models';

import { EboNameObjectTO } from '../base-classes/ebo-name-object-to';
import { MaintPlanItem } from './maint-plan-item';

export class MaintPlan extends EboNameObjectTO implements SBaseDisplay {
  description: string;
  planItems: MaintPlanItem[];

  get planItemsFormatted(): SummitFormattedText {
    const response = new SummitFormattedText();
    if (this.planItems) {
      this.planItems.forEach((item) => {
        response.AddLine(item.toShortString());
      });
    }
    return response;
  }

  constructor(jsonData?: Partial<MaintPlan>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.planItems) this.planItems = jsonData.planItems.map((item) => new MaintPlanItem(item));
    }
    this.planItems ??= [];
  }
  toShortString(): string {
    return this.name;
  }
}
